import { type FC } from 'react';

import { PrivacyText, LEGAL_DOCS } from '@entities/legal';
import { LegalDocument } from '@shared/ui/LegalDocument';

const PrivacyPage: FC = () => (
  <LegalDocument title={LEGAL_DOCS.privacy.title}>
    <PrivacyText />
  </LegalDocument>
);

export default PrivacyPage;
